import { BellIcon, EllipsisIcon, EyeClosedIcon, EyeIcon, MoneyIcon, UserIcon } from "@xola/icons";
import { Checkbox, PopoverList } from "@xola/ui-kit";
import { SecondaryButton } from "common";
import React from "react";
import { Merchandise } from "types";
import { useModal } from "@/hooks/useVisibility";
import { isInventoryTracked } from "@/models/Merchandise";

export enum VariantBulkAction {
    SET_PRICE = "set_price",
    SET_LOW_INVENTORY = "set_low_inventory",
    SET_CONTINUE_SELLING = "set_continue_selling",
    PUBLISH = "publish",
    UNPUBLISH = "unpublish",
}

interface VariantActionsHeaderProps {
    selectedCount: number;
    isAllSelected: boolean;
    isIndeterminate: boolean;
    merchandise: Merchandise;
    onActionClick: (action: VariantBulkAction) => void;
    onToggleSelectAll: () => void;
}

export const VariantActionsHeader = ({
    selectedCount,
    isAllSelected,
    isIndeterminate,
    merchandise,
    onActionClick,
    onToggleSelectAll,
}: VariantActionsHeaderProps) => {
    const popover = useModal();

    const handleActionClick = (action: VariantBulkAction) => {
        popover.hide();
        onActionClick(action);
    };

    const hasTrackedInventory = isInventoryTracked(merchandise);

    return (
        <div className="flex items-center justify-end space-x-2">
            <PopoverList distance={7} className="w-65" visible={popover.isVisible} onClickOutside={popover.hide}>
                <SecondaryButton size="small" disabled={selectedCount === 0} onClick={popover.toggle}>
                    <EllipsisIcon size="small" />
                </SecondaryButton>
                <PopoverList.Item name="set-price" onClickItem={() => handleActionClick(VariantBulkAction.SET_PRICE)}>
                    <div className="flex items-center space-x-2">
                        <MoneyIcon size="small" />
                        <span>Set Price</span>
                    </div>
                </PopoverList.Item>
                {hasTrackedInventory && (
                    <PopoverList.Item
                        name="set-low-inventory"
                        onClickItem={() => handleActionClick(VariantBulkAction.SET_LOW_INVENTORY)}
                    >
                        <div className="flex items-center space-x-2">
                            <BellIcon size="small" />
                            <span>Set Low Inventory Alert Levels</span>
                        </div>
                    </PopoverList.Item>
                )}
                {hasTrackedInventory && (
                    <PopoverList.Item
                        name="set-continue-selling"
                        onClickItem={() => handleActionClick(VariantBulkAction.SET_CONTINUE_SELLING)}
                    >
                        <div className="flex items-center space-x-2">
                            <UserIcon size="small" />
                            <span>Set Continue Selling when Out of Stock</span>
                        </div>
                    </PopoverList.Item>
                )}
                <PopoverList.Item name="publish" onClickItem={() => handleActionClick(VariantBulkAction.PUBLISH)}>
                    <div className="flex items-center space-x-2">
                        <EyeIcon size="small" />
                        <span>Publish</span>
                    </div>
                </PopoverList.Item>
                <PopoverList.Item name="unpublish" onClickItem={() => handleActionClick(VariantBulkAction.UNPUBLISH)}>
                    <div className="flex items-center space-x-2">
                        <EyeClosedIcon size="small" />
                        <span>Unpublish</span>
                    </div>
                </PopoverList.Item>
            </PopoverList>
            <Checkbox
                label=""
                checked={isAllSelected}
                indeterminate={isIndeterminate ? true : undefined}
                onChange={onToggleSelectAll}
            />
        </div>
    );
};
